import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=a0c52522&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&lang=js"
export * from "./ActivityItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=a0c52522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c52522",
  null
  
)

export default component.exports